export default {"src":"/_next/static/media/3-paws.cfd99adb.svg","height":79,"width":89,"blurWidth":0,"blurHeight":0};